import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export var getBreakpointIndex = function(param) {
    var width = param.width, breakpoints = param.breakpoints;
    var breakpointPixels = _to_consumable_array(breakpoints).reverse().find(function(breakpoint) {
        return width >= breakpoint;
    });
    var breakpointIndex = breakpoints.findIndex(function(breakpoint) {
        return breakpointPixels === breakpoint;
    });
    breakpointIndex = breakpointIndex === -1 ? 0 : breakpointIndex + 1;
    return breakpointIndex;
};
